import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import React, { createContext, useState, useContext } from 'react';

var DefaultFeedbackModalContextProps = {
  isModalOpen: false,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  openModal: function openModal() {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  closeModal: function closeModal() {}
};
var FeedbackModalContext = createContext(DefaultFeedbackModalContextProps);
var useFeedbackModal = function useFeedbackModal() {
  return useContext(FeedbackModalContext);
};
var FeedbackModalProvider = function FeedbackModalProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFeedbackModalVisible = _useState2[0],
    setIsFeedbackModalVisible = _useState2[1];
  var closeModal = function closeModal() {
    setIsFeedbackModalVisible(false);
  };
  var openModal = function openModal() {
    setIsFeedbackModalVisible(true);
  };
  return /*#__PURE__*/React.createElement(FeedbackModalContext.Provider, {
    value: {
      isModalOpen: isFeedbackModalVisible,
      openModal: openModal,
      closeModal: closeModal
    }
  }, children);
};

export { DefaultFeedbackModalContextProps, FeedbackModalContext, FeedbackModalProvider, useFeedbackModal };
